module.exports = __webpack_public_path__ + "static/media/des7.644904bb.jpg";